module.exports = __webpack_public_path__ + "static/media/map-screenshot.b5d62436.png";